import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {socialMediaConfiguration} from './conf';
import './index.scss';

const SocialMedium = ({socialMedium, onClick}) => {
    const availableMedia = socialMediaConfiguration;
    const {medium, isLoading, isVisited} = socialMedium;
    if (medium !== 'undefined' && Object.keys(availableMedia).indexOf(medium) === -1) {
        throw new TypeError('Social medium: social medium is not defined properly');
    }

    const socialMediumClasses = classNames('social-medium', {'is-loading': isLoading, 'is-visited': isVisited && medium === 'copy_link'}),
        image = React.createElement(availableMedia[medium].reactComponent, {className: 'social-medium-image'});
    let description;

    description = i18n.t(availableMedia[medium].description);

    if (isVisited && medium === 'copy_link') {
        description = i18n.t('sharing_link.medium.visited.copy_link');
    }

    return (
        <li className={socialMediumClasses} onClick={!isLoading && onClick}>
            <div>{image}</div>
            <span>{description}</span>
        </li>
    );
};

SocialMedium.propTypes = {
    socialMedium: PropTypes.shape({
        medium: PropTypes.string.isRequired,
        isLoading: PropTypes.bool,
        isVisited: PropTypes.bool
    }).isRequired,
    onClick: PropTypes.func.isRequired
};

SocialMedium.defaultProps = {
    socialMedium: {
        medium: '',
        isLoading: false,
        isVisited: false
    }
};

export default SocialMedium;



// WEBPACK FOOTER //
// ./src/components/SocialMedium/index.js